// src/NewPage.js
import React, {createContext, useContext, useEffect, useState} from 'react';
import { useUser } from '../auth/UserContext';
import './header.css';
import {useLocation} from "react-router-dom";

const HeaderNavBar = () => {
    function activeAI() {

        const  buttonElement = document.getElementsByClassName('fda3723591e0b38e7e52')
        if (buttonElement) {
            buttonElement[0].click(); // 触发点击事件
        }
    }

    return (
        <nav
            className="row col-12 navbar EL-main-nav navbar-expand-sm d-none d-lg-flex"
            id="subheader-nav"
            role="navigation"
        >
            <div className="navbar-padding navbar-collapse collapse d-flex justify-content-end">
                <ul id="subheader-navbar" className="nav float-end navbar-nav">
                    <li className="nav-li-subheader">
                        <a href="/" className="nav-releasecal-subheader-gtm">
                            数据首页
                        </a>
                    </li>

                    <li className="nav-li-subheader">
                        <a
                            href="#"
                            onClick={activeAI}
                            className="nav-releasecal-subheader-gtm"
                            style={{color:'#6b4a9f'}}
                        >
                            AI问答
                            <img src='/new.png' alt='new' style={{
                                marginLeft:'5px',
                                float: 'right',
                                top: '-5px',
                                position: 'relative'
                            }}/>
                        </a>

                    </li>
                    <li className="nav-li-subheader">
                        <a
                            href="/tools"
                            className="nav-releasecal-subheader-gtm"
                        >
                            Rabbit工具
                        </a>
                    </li>
                    <li className="nav-li-subheader">
                        <a
                            href="https://blog.datarabbit.com.cn/"
                            className="nav-releasecal-subheader-gtm"
                        >
                            谷子观数Blog
                        </a>
                    </li>
                    <li className="nav-li-subheader">
                        <a
                            href="https://blog.datarabbit.com.cn/aboutus"
                            className="nav-releasecal-subheader-gtm"
                        >
                            关于数据兔
                        </a>
                    </li>
                </ul>
            </div>
        </nav>
    )
}

function useQuery() {
    return new URLSearchParams(useLocation().search);
}


export const NonHomeHeader = () => {

    const [totalSeries, setTotalSeries] = useState(0);
    const query = useQuery();
    const [searchValue, setSearchValue] = useState('');

    useEffect(() => {
        // 从 URL 参数中获取初始值
        setSearchValue(query.get("st"));
        console.log("ee")
    }, []);

    const handleSearchChange = (event) => {
        console.log(event.target.value)
        setSearchValue(event.target.value);
    };

    useEffect(() => {
        const fetchData = () => {
            fetch("/api/series/total").then(response=>response.json()).then(data=>{
                setTotalSeries(data.data)
            })
        };

        fetchData();
    }, []);

    return (

        <header className="EL-header-and-subheader" style={{display: "block", height: "auto", background: "inherit"}}>
            <nav className="navbar navbar-expand-lg header-not-home py-0 EL-nonhomepage-header EL-header-and-subheader">
                <HeaderTop/>
            </nav>
            <div className="navbar navbar-expand-lg sub-header EL-header-and-subheader">
                <div className="container-fluid gx-0">
                    <div
                        className="col-lg-3 col-md-3 d-none d-lg-block"
                        style={{paddingLeft: 15, paddingRight: 15}}
                    >
                        <a className="fred-logo-gtm" href="/">
                            <img
                                id="fred-logo-subheader"
                                src="/static/images/fred-logo-2x.png"
                                alt="Data Rabbit"
                            />
                        </a>
                    </div>
                    <h1
                        className="col-lg-2 fred-trust-text d-none d-xl-block d-flex align-self-center"
                        role="presentation"
                        style={{
                            padding: "45px 0px 45px",
                            marginLeft: "-1px",
                            fontWeight: 400
                        }}
                    >
                        <p className="mb-0">做值得信任的数据服务商</p>
                        <p style={{marginTop: 10}}>
                            我们收录的数据
                            <span style={{color: "#456089"}}>
                                已有 <b style={{color: "#456089"}}>{totalSeries}</b> 条
          </span>
                        </p>
                    </h1>
                    <div
                        className="col d-flex justify-content-end"
                        style={{paddingLeft: 15, paddingRight: 15}}
                    >
                        <div className="container-fluid gx-0">
                            <div className="search-header-div float-end col-8 d-none d-lg-block">
                                <form
                                    method="GET"
                                    name="mainform"
                                    action="/searchresults"
                                    style={{display: "inline"}}
                                >
                                    <div
                                        className="input-group EL-header-search-container"
                                        id="search-container-header"
                                        style={{borderRadius: 45, backgroundColor: "#6b4a9f"}}
                                    >
                                        <input
                                            type="text"
                                            name="st"
                                            style={{
                                                borderRadius: "25px 0 0 25px",
                                                backgroundColor: "#6b4a9f",
                                                borderRight: 0,
                                                color: "#fff",
                                                fontFamily: "Roboto,sans-serif",
                                                border: "none",
                                                height: 45,
                                                width: "100%",
                                                paddingLeft: 20,
                                                fontSize: 16
                                            }}
                                            className="search-text-input select2-container--default"
                                            value={searchValue}
                                            onChange={handleSearchChange}
                                        ></input>

                                        <button
                                            className="btn search-submit-select2"
                                            id="select2-nav-search-button"
                                            aria-label="search"
                                            type="submit"
                                            style={{
                                                backgroundColor: "#4b3c70 !important",
                                                borderRadius: "45px !important",
                                                width: 45
                                            }}
                                        >
                                            <i className="fa fa-search" style={{padding: 0}}/>
                                        </button>
                                    </div>
                                </form>
                            </div>
                            <HeaderNavBar/>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    )

}

export const HomeHeader = () => {
    return (
        <header className="EL-header-and-subheader" style={{display: 'block', height: 'auto', background: 'inherit'}}>
            <div className="navbar navbar-expand-lg py-0 EL-header-and-subheader" id="header-home">
                <HeaderTop/>
            </div>
            <div className="col-12 homepage-subheader-spacing">
                <HeaderNavBar/>
            </div>
        </header>
    )

}

const HeaderTop = () => {
    // 创建一个上下文

    const {userinfo, isLogin} = useUser()
    let pathname = window.location.pathname;
    let searchParams = window.location.search;
    let redirectPath = pathname;
    if (searchParams) {
        redirectPath += searchParams;
    }
    let baseUrl = new URL(window.location.href).origin;
    let callbackUrl = baseUrl + "/api/wechat/callback?page=" + baseUrl+redirectPath;
    // 打印主机名和端口
    let loginUrl = "https://open.weixin.qq.com/connect/qrconnect?appid=wxb84248adb50a775b&redirect_uri=" + encodeURIComponent(callbackUrl) + "&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect"

    

    
    return (
        <>
            <div id="hidden-user" className="hide"/>
            <div id="action-modal"/>
            <div className="container-fluid align-items-stretch gx-0">
                <div className="col-3" style={{paddingLeft: 15, paddingRight: 15}}>
                    <a
                        className="research-logo-gtm"
                        href="#/"
                        previewlistener="true"
                    >
                        <img
                            className="header-logo-eagle d-none d-lg-block"
                            src="/static/images/masthead.png"
                            alt="Federal Reserve bank of St. Louis logo"
                        />
                        <img
                            className="header-logo-eagle d-lg-none"
                            src="/static/images/logo-eagle.png"
                            alt="Eagle Logo"
                        />
                    </a>
                </div>
                <div className="fred-logo-div col-6 d-lg-none">
                    <a className="fred-logo-gtm" href="/" previewlistener="true">
                        <picture>
                            <img
                                className="header-logo"
                                src="/static/images/fred-masthead-mobile-2x.png"
                                alt="mini rabbit logo"
                            />
                        </picture>
                    </a>
                </div>
                <style
                    type="text/css"
                    dangerouslySetInnerHTML={{
                        __html:
                            "\n                #blueheader-navbar>li>a{\n                    color: #fff;\n                    padding:5px 30px 5px 0px;\n                    cursor: pointer;\n                }\n            "
                    }}
                />
                <div
                    className="col-lg-8 col-3 d-flex justify-content-end"
                    style={{paddingLeft: 15, paddingRight: 0}}
                >
                    <nav id="blueheader-navbar-nav" style={{height: "100%"}}>
                        <ul id="blueheader-navbar" className="nav float-end">
                            {
                                !isLogin ?
                                    (<li className="user-no-login"><a id="login_btn" href={loginUrl}>| 登录 |</a>
                                    </li>)
                                    :
                                    (
                                        <li className="user-login" style={{width: '140px',display: 'contents'}}>
                                            <img src={userinfo.avatar}/>
                                            <a href="#/"
                                               style={{padding: "10px 30px 10px 10px"}}>{userinfo.nickname}</a>
                                        </li>
                                    )
                            }
                        </ul>
                    </nav>
                </div>
            </div>
            <div id="notifications-container"/>
        </>
    );
};

export default HeaderTop;
